/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description Code explorer icons and images
 */
import NO_ADDITIONAL_DETAILED_VIEW from 'assets/codeExplorer/no-additional-detailed-view.svg';
import NO_FAVOURITE_CODE from 'assets/codeExplorer/favorite.svg';
import NO_INTERNAL_NOTE from 'assets/codeExplorer/internal-notes.svg';
import NO_RESULT_FOUND_IMAGE from 'assets/no-result-found.svg';

import AGE_HCPCS_ICD from 'assets/codeExplorer/legends/age-hcpcs-icd.svg';
import ASC_PAYMENT_INDICATOR_HCPCS from 'assets/codeExplorer/legends/ASC-Payment-Indicator-hcpcs.svg';
import CARRIER_JUDGEMENT_HCPCS from 'assets/codeExplorer/legends/Carrier-Judgement-hcpcs.svg';
import CLIA_WAIVED_TEST_HCPCS from 'assets/codeExplorer/legends/CLIA-Waived-Tesr-hcpcs.svg';
import FEMALE_HCPCS_ICD from 'assets/codeExplorer/legends/female-hcpcs-icd.svg';
import HOSPITAL_ACQUIRED_CONDITIONS_ICD from 'assets/codeExplorer/legends/Hospital-Acquired-Conditions-icd.svg';
import MALE_HCPCS_ICD from 'assets/codeExplorer/legends/male-hcpcs-icd.svg';
import MANIFESTATION_CODES_AS_PRIMARY_DIAGNOSIS_ICD from 'assets/codeExplorer/legends/Manifestation-codes-as-Primary-Diagnosis-icd.svg';
import MATERNITY_HCPCS_ICD from 'assets/codeExplorer/legends/Maternity-hcpcs-icd.svg';
import NEWBORN_HCPCS_ICD from 'assets/codeExplorer/legends/Newbor-hcpcs-icd.svg';
import NEW_CODE_HCPCS_ICD from 'assets/codeExplorer/legends/New-Code-hcpcs-icd.svg';
import NON_COVERED_BY_MEDICARE_HCPCS from 'assets/codeExplorer/legends/Non-covered-by-Medicare-hcpcs.svg';
import NON_COVERED_BY_MEDICARE_STATUTE_HCPCS from 'assets/codeExplorer/legends/Non-covered-by-Medicare-statute.svg';
import NOT_PAYABLE_BY_MEDICARE_HCPCS from 'assets/codeExplorer/legends/Not-payable-by-Medicare-hcpcs.svg';
import POA_EXEMPT_ICD from 'assets/codeExplorer/legends/POA-Exempt-icd.svg';
import PRINCIPAL_ICD from 'assets/codeExplorer/legends/Principal-icd.svg';
import REVISED_CODE_HCPCS_ICD from 'assets/codeExplorer/legends/Revised-Code-hcpcs-icd.svg';
import SPECIAL_COVERAGE_INSTRUCTIONS_APPLY_HCPCS from 'assets/codeExplorer/legends/Special-coverage-instructions-apply-hcpcs.svg';
import UNACCEPTABLE_PRINCIPAL_DIAGNOSIS_ICD from 'assets/codeExplorer/legends/Unacceptable-Principal-Diagnosis-icd.svg';
import ADD_ON_CODE from 'assets/codeExplorer/legends/add-on-code.svg';
import FDA_APPROVAL_PENDING from 'assets/codeExplorer/legends/fda-approval-pending.svg';
import MODIFIER_51 from 'assets/codeExplorer/legends/Modifier-51-exempt.svg';
import MODIFIER_63 from 'assets/codeExplorer/legends/Modifier-63-exempt.svg';
import RESEQUENCED_CODE from 'assets/codeExplorer/legends/resequenced-code.svg';
import TELEMEDICINE_CODE from 'assets/codeExplorer/legends/telemedicine-code.svg';
import AUDIO_ONLY from 'assets/codeExplorer/legends/Audio-Only.svg';
import OPERATING_ROOM from 'assets/codeExplorer/legends/Operating-Room-Procedure.svg';
import MAJOR_COMPLICATION_OR_COMORBIDITY from 'assets/codeExplorer/legends/Major-Complication-or-Comorbidity.svg';
import COMPLICATION_OR_COMORBIDITY from 'assets/codeExplorer/legends/Complication-or-Comorbidity.svg';
import { CODE_SET_MAPPING } from 'app-constants/codeExplorer';

// code explorer images
const codeExplorerImages = {
	getNoResultFoundImage: (): string => NO_RESULT_FOUND_IMAGE,
	getInternalNoteImage: (): string => NO_INTERNAL_NOTE,
	getFavouriteCodeImage: (): string => NO_FAVOURITE_CODE,
	getAdditionalDetailedViewImage: (): string => NO_ADDITIONAL_DETAILED_VIEW,
};

// HCPCS code explorer icons
const codeExplorerHCPCSIcons = {
	ascPaymentIndicator: {
		label: 'ASC Payment Indicator',
		image: (): string => ASC_PAYMENT_INDICATOR_HCPCS,
	},
	carrierJudgement: {
		label: 'Carrier Judgement',
		image: (): string => CARRIER_JUDGEMENT_HCPCS,
	},
	specialCoverageInstructionsApply: {
		label: 'Special coverage instructions apply',
		image: (): string => SPECIAL_COVERAGE_INSTRUCTIONS_APPLY_HCPCS,
	},
	nonCoveredByMedicare: {
		label: 'Non-covered by Medicare',
		image: (): string => NON_COVERED_BY_MEDICARE_HCPCS,
	},
	notPayableByMedicare: {
		label: 'Not payable by Medicare',
		image: (): string => NOT_PAYABLE_BY_MEDICARE_HCPCS,
	},
	nonCoveredByMedicareStatute: {
		label: 'Non-covered by Medicare Statute',
		image: (): string => NON_COVERED_BY_MEDICARE_STATUTE_HCPCS,
	},
	newCode: {
		label: 'New Code',
		image: (): string => NEW_CODE_HCPCS_ICD,
	},
	revisedCode: {
		label: 'Revised Code',
		image: (): string => REVISED_CODE_HCPCS_ICD,
	},
	age: {
		label: 'Age',
		image: (): string => AGE_HCPCS_ICD,
	},
	female: {
		label: 'Female',
		image: (): string => FEMALE_HCPCS_ICD,
	},
	male: {
		label: 'Male',
		image: (): string => MALE_HCPCS_ICD,
	},
	maternity: {
		label: 'Maternity',
		image: (): string => MATERNITY_HCPCS_ICD,
	},
	cliaWaivedTest: {
		label: 'CLIA-Waived Test',
		image: (): string => CLIA_WAIVED_TEST_HCPCS,
	},
	newborn: {
		label: 'Newborn',
		image: (): string => NEWBORN_HCPCS_ICD,
	},
};

// ICD code explorer icons
const codeExplorerICDIcons = {
	principal: {
		label: 'Principal/First-listed diagnosis',
		image: (): string => PRINCIPAL_ICD,
	},
	unacceptablePrincipalDiagnosis: {
		label: 'Unacceptable Principal Diagnosis',
		image: (): string => UNACCEPTABLE_PRINCIPAL_DIAGNOSIS_ICD,
	},
	hospitalAcquiredConditions: {
		label: 'Hospital Acquired Conditions',
		image: (): string => HOSPITAL_ACQUIRED_CONDITIONS_ICD,
	},
	complicationOrComorbidity: {
		label: 'Complication or Comorbidity',
		image: (): string => COMPLICATION_OR_COMORBIDITY,
	},
	majorComplicationOrComorbidity: {
		label: 'Major Complication or Comorbidity',
		image: (): string => MAJOR_COMPLICATION_OR_COMORBIDITY,
	},
	poaExempt: {
		label: 'POA Exempt',
		image: (): string => POA_EXEMPT_ICD,
	},
	newborn: {
		label: 'Newborn',
		image: (): string => NEWBORN_HCPCS_ICD,
	},
	age: {
		label: 'Age',
		image: (): string => AGE_HCPCS_ICD,
	},
	manifestationCodesAsPrimaryDiagnosis: {
		label: 'Manifestation codes as Principal Diagnosis',
		image: (): string => MANIFESTATION_CODES_AS_PRIMARY_DIAGNOSIS_ICD,
	},
	newCode: {
		label: 'New Code',
		image: (): string => NEW_CODE_HCPCS_ICD,
	},
	revisedCode: {
		label: 'Revised Code',
		image: (): string => REVISED_CODE_HCPCS_ICD,
	},
	maternity: {
		label: 'Maternity',
		image: (): string => MATERNITY_HCPCS_ICD,
	},
	female: {
		label: 'Female',
		image: (): string => FEMALE_HCPCS_ICD,
	},
	male: {
		label: 'Male',
		image: (): string => MALE_HCPCS_ICD,
	},
};

const codeExplorerCPTIcons = {
	newCode: {
		label: 'New Code',
		image: (): string => NEW_CODE_HCPCS_ICD,
	},
	revisedCode: {
		label: 'Revised Code',
		image: (): string => REVISED_CODE_HCPCS_ICD,
	},
	addOnCode: {
		label: 'Add-on Code',
		image: (): string => ADD_ON_CODE,
	},
	modifier51: {
		label: 'Modifier 51 exempt',
		image: (): string => MODIFIER_51,
	},
	modifier63: {
		label: 'Modifier 63 exempt',
		image: (): string => MODIFIER_63,
	},
	fdaApprovalPending: {
		label: 'FDA Approval pending',
		image: (): string => FDA_APPROVAL_PENDING,
	},
	resequencedCode: {
		label: 'Resequenced Code',
		image: (): string => RESEQUENCED_CODE,
	},
	telemedicineCode: {
		label: 'Telemedicine Code',
		image: (): string => TELEMEDICINE_CODE,
	},
	audioOnly: {
		label: 'Audio Only',
		image: (): string => AUDIO_ONLY,
	},
};

const codeExplorerICD10PCSIcons = {
	newCode: {
		label: 'New Code',
		image: (): string => NEW_CODE_HCPCS_ICD,
	},
	revisedCode: {
		label: 'Revised Code',
		image: (): string => REVISED_CODE_HCPCS_ICD,
	},
	hospitalAcquiredConditions: {
		label: 'Hospital Acquired Conditions',
		image: (): string => HOSPITAL_ACQUIRED_CONDITIONS_ICD,
	},
	operatingRoom: {
		label: 'Operating Room Procedure',
		image: (): string => OPERATING_ROOM,
	},
};

const ICD_ICONS = [
	{
		key: 'ageconflict:newborndiagnoses',
		label: 'Newborn',
		image: (): string => NEWBORN_HCPCS_ICD,
	},
	// {
	// 	key: 'ageconflict:pediatricdiagnoses',
	// 	label: 'Pediatric Diagnoses',
	// image: (): string => PEDIATRIC_DIAGNOSES_ICD, // TODO: Add icon import when available
	// },
	{
		key: 'ageconflict:maternitydiagnoses',
		label: 'Maternity',
		image: (): string => MATERNITY_HCPCS_ICD,
	},
	// {
	// 	key: 'ageconflict:adultdiagnoses',
	// 	label: 'Adult Diagnoses',
	// 	image: (): string => ADULT_DIAGNOSES_ICD, // TODO: Add icon import when available
	// },
	{
		key: 'manifestationcodeasprincipaldiagnosis',
		label: 'Manifestation codes as Principal Diagnosis',
		image: (): string => MANIFESTATION_CODES_AS_PRIMARY_DIAGNOSIS_ICD,
	},
	{
		key: 'unacceptableprincipaldiagnosis',
		label: 'Unacceptable Principal Diagnosis',
		image: (): string => UNACCEPTABLE_PRINCIPAL_DIAGNOSIS_ICD,
	},
	{
		key: 'presentonadmissionexempt',
		label: 'POA Exempt',
		image: (): string => POA_EXEMPT_ICD,
	},
	{
		key: 'majorcomplicationorcomorbidity',
		label: 'Major Complication or Comorbidity',
		image: (): string => MAJOR_COMPLICATION_OR_COMORBIDITY,
	},
	{
		key: 'complicationorcomorbidity',
		label: 'Complication or Comorbidity',
		image: (): string => COMPLICATION_OR_COMORBIDITY,
	},
	{
		key: 'hospitalacquiredconditions',
		label: 'Hospital Acquired Conditions',
		image: (): string => HOSPITAL_ACQUIRED_CONDITIONS_ICD,
	},
	{
		key: 'operatingroom',
		label: 'Operating Room Procedure',
		image: (): string => OPERATING_ROOM,
	},
	{
		key: 'newcode',
		label: 'New Code',
		image: (): string => NEW_CODE_HCPCS_ICD,
	},
	// {
	// 	key: 'deletedcode',
	// 	label: 'Deleted Code',
	// 	image: (): string => DELETED_CODE_ICD, // TODO: Add icon import when available
	// },
	{
		key: 'revisedcode',
		label: 'Revised Code',
		image: (): string => REVISED_CODE_HCPCS_ICD,
	},
];

const CPT_ICONS = [
	{
		key: 'appendixt:synchronousrealtimeinteractiveaudioonlytelemedicineservices',
		label: 'Audio Only',
		image: (): string => AUDIO_ONLY,
	},
	{
		key: 'appendixp:synchronousrealtimeinteractiveaudiovideotelemedicineservices',
		label: 'Telemedicine Code',
		image: (): string => TELEMEDICINE_CODE,
	},
	{
		key: 'appendixk:productpendingfdaapproval',
		label: 'FDA Approval pending',
		image: (): string => FDA_APPROVAL_PENDING,
	},
	{
		key: 'appendixe:summaryofcptcodesexemptfrommodifier51',
		label: 'Modifier 51 exempt',
		image: (): string => MODIFIER_51,
	},
	{
		key: 'appendixf:summaryofcptcodesexemptfrommodifier63',
		label: 'Modifier 63 exempt',
		image: (): string => MODIFIER_63,
	},
	{
		key: 'appendixd:summaryofcptaddoncodes',
		label: 'Add-on Code',
		image: (): string => ADD_ON_CODE,
	},
	{
		key: 'appendixn:resequencedcode',
		label: 'Resequenced Code',
		image: (): string => RESEQUENCED_CODE,
	},
	// {
	// 	key: 'appendixm:deletedcodes',
	// 	label: 'Deleted Code',
	// 	image: (): string => DELETED_CODE, // TODO: Add icon import when available
	// },
	{
		key: 'appendixb:newcode',
		label: 'New Code',
		image: (): string => NEW_CODE_HCPCS_ICD,
	},
	{
		key: 'appendixb:revisedcode',
		label: 'Revised Code',
		image: (): string => REVISED_CODE_HCPCS_ICD,
	},
	{
		key: 'appendixb:resequencedcode',
		label: 'Resequenced Code',
		image: (): string => RESEQUENCED_CODE,
	},
	{
		key: 'appendixb:addoncode',
		label: 'Add-on Code',
		image: (): string => ADD_ON_CODE,
	},
	{
		key: 'appendixb:modifier51exempt',
		label: 'Modifier 51 exempt',
		image: (): string => MODIFIER_51,
	},
	{
		key: 'appendixb:telemedicinecode',
		label: 'Telemedicine Code',
		image: (): string => TELEMEDICINE_CODE,
	},
	// {
	// 	key: 'appendixb:categoryipla',
	// 	label: 'Category I PLA',
	// 	image: (): string => CATEGORY_I_PLA, // TODO: Add icon import when available
	// },
	{
		key: 'appendixb:audioonly',
		label: 'Audio Only',
		image: (): string => AUDIO_ONLY,
	},
	{
		key: 'appendixb:fdaapprovalpending',
		label: 'FDA Approval pending',
		image: (): string => FDA_APPROVAL_PENDING,
	},
	// {
	// 	key: 'appendixb:duplicateplatest',
	// 	label: 'Duplicate PLA Test',
	// 	image: (): string => DUPLICATE_PLA_TEST, // TODO: Add icon import when available
	// },
];

const HCPCS_ICONS = [
	{
		key: 'coverage:carrierjudgment',
		label: 'Carrier Judgement',
		image: (): string => CARRIER_JUDGEMENT_HCPCS,
	},
	{
		key: 'coverage:specialcoverageinstructionsapply',
		label: 'Special coverage instructions apply',
		image: (): string => SPECIAL_COVERAGE_INSTRUCTIONS_APPLY_HCPCS,
	},
	{
		key: 'coverage:notpayablebymedicare',
		label: 'Not payable by Medicare',
		image: (): string => NOT_PAYABLE_BY_MEDICARE_HCPCS,
	},
	{
		key: 'coverage:noncoveredbymedicare',
		label: 'Non-covered by Medicare',
		image: (): string => NON_COVERED_BY_MEDICARE_HCPCS,
	},
	{
		key: 'coverage:noncoveredbymedicarestatute',
		label: 'Non-covered by Medicare Statute',
		image: (): string => NON_COVERED_BY_MEDICARE_STATUTE_HCPCS,
	},
	{
		key: 'newcode',
		label: 'New Code',
		image: (): string => NEW_CODE_HCPCS_ICD,
	},
	// {
	// 	key: 'deletedcode',
	// 	label: 'Deleted Code',
	// 	image: (): string => DELETED_CODE, // TODO: Add icon import when available
	// },
	{
		key: 'revisedcode',
		label: 'Revised Code',
		image: (): string => REVISED_CODE_HCPCS_ICD,
	},
];

const getIconMapping = (codeSet: string): { key: string; label: string; image: () => string }[] => {
	if (codeSet === CODE_SET_MAPPING.ICD10CM || codeSet === CODE_SET_MAPPING.ICD10PCS) {
		return ICD_ICONS;
	}
	if (codeSet === CODE_SET_MAPPING.CPT) {
		return CPT_ICONS;
	}
	if (codeSet === CODE_SET_MAPPING.HCPCS) {
		return HCPCS_ICONS;
	}
	return [];
};

const getLegendMapping = (codeSet: string): Record<string, { label: string; image: () => string }> => {
	const mapping = {
		[CODE_SET_MAPPING.ICD10CM]: codeExplorerICDIcons,
		[CODE_SET_MAPPING.CPT]: codeExplorerCPTIcons,
		[CODE_SET_MAPPING.HCPCS]: codeExplorerHCPCSIcons,
		[CODE_SET_MAPPING.ICD10PCS]: codeExplorerICD10PCSIcons,
	};
	if (mapping[codeSet]) {
		return mapping[codeSet];
	}
	return {};
};

export {
	codeExplorerImages,
	codeExplorerHCPCSIcons,
	codeExplorerICDIcons,
	codeExplorerCPTIcons,
	ICD_ICONS,
	CPT_ICONS,
	HCPCS_ICONS,
	codeExplorerICD10PCSIcons,
	getIconMapping,
	getLegendMapping,
};
